import React, { useMemo, useCallback } from "react"
import { useDispatch, useSelector } from "react-redux";
import { onChangeAction } from "../../../../../redux/modals/modal-inline-mod-check/actionModal";

const ModalAction = () => {
    const dispatch = useDispatch();

    // Оптимизированные селекторы с более читаемыми именами
    const chooseActionPhrase = useSelector((state) => 
        state.lots.phrases.ak_au_ph_choose_an_action
    );

    const options = useSelector((state) => 
        state.modal.option
    );

    // Мемоизация обработчика события для предотвращения лишних перерендеров
    const handleSelectChange = useCallback((e) => {
        const value = parseInt(e.target.value);
        dispatch(onChangeAction(value));
    }, [dispatch]);

    // Мемоизация опций для предотвращения лишних перерендеров
    const renderedOptions = useMemo(() => {
        return options
            .filter(({ view }) => view())
            .map(({ phrase, value }) => (
                <option key={value} value={value}>
                    {phrase}
                </option>
            ));
    }, [options]);

    return (
        <div className="col-12 my-2">
            <select 
                defaultValue={0} 
                id="select_action"
                className="form-select my-1"
                onChange={handleSelectChange}
            >
                <option disabled value={0}>
                    {chooseActionPhrase}
                </option>
                {renderedOptions}
            </select>
        </div>
    );
};

export default ModalAction;